// Hari K : 20-06-2023 : BT-107424 - Breeze -events-detailed eventmodal-start
import { memo, useCallback,useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BzChip, BzHeading, BzModal, BzModalBody, BzModalHeader, BzToolTip } from "../../components";
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { useSelector, useDispatch } from 'react-redux';
import { getExchangeWiseScripInfo, getScripOrderInfo, getSpreadOrder } from "../../redux/actions/orders";
import { FACILITY_NUM, TL_INDEX, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { sendTouchlineRequest } from "../../apis/web_socket";
import { useWFHMessages } from "../../hooks";
import { getWfhTouchlineLastTick } from "../../redux/actions/wfh";
import { convertDateToSeconds, getApiExchangeNameFromMktSegId, getMappedMktSegIdFromApiExchangeName, getMktSegIdFromMappedMktSegId, getScripDisplayDescription, isUserIsAGuest, removeExpiriedScrip, convertScripResponseWatchlistGrid } from "../../utils/global_functions";
import { toastConfig } from "../../redux/actions/toast";
import { setArrScripToBeAdded } from "../../redux/actions/globalSearch";
import { setScripOverviewData } from "../../redux/actions/marketOverview";
import { setIsIndicesOverview } from "../../redux/actions/indices";
import { getScripInfo } from "../../redux/actions/scripInfo";




const EventDetailsModal = ({ detailedEvent }) => {

    const dispatch = useDispatch();
    const [eventData, setEventData] = useState();
    const modals = useSelector(state => state?.modals?.modals);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const objCFT = useSelector(state => state?.auth?.objCFT);
    const [arrRowData, setArrRowData] = useState([])

    // useEffect(() => {

    // }, [detailedEvent])

    useEffect(() => {
        setEventData({ ...detailedEvent });
    }, [detailedEvent]);

    // Hari K: events LTP functionality-start
    useEffect(() => {
        if (detailedEvent?.scripobj !== "-") {
            const arrSubscriptionScrips = { exchangeId: detailedEvent?.nSegmentId, token: detailedEvent?.scripobj?.ODINCode, isSubscribe: true };
            sendTouchlineRequest([arrSubscriptionScrips]);
            const scrip = [{
                "mkt": getApiExchangeNameFromMktSegId(detailedEvent?.nSegmentId), "token": detailedEvent?.scripobj?.ODINCode
            }]
            dispatch(getScripInfo(scrip)).then((res) => setArrRowData(convertScripResponseWatchlistGrid(res)))
        } else { }
    }, [detailedEvent]);


    const handleEventsLiveData = (arrTouchLineData) => {
        if (detailedEvent?.nSegmentId + '_' + detailedEvent?.scripobj?.ODINCode === arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN]) {
            const updatedEventDetails = {
                ...detailedEvent,
                ltp: arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE],
                changeInPersent: arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE],
                changeInPrice: arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE],
            };
            setEventData(updatedEventDetails);
        } else { }
    };

    useWFHMessages('touchline', (e) => {
        handleEventsLiveData([...e.detail]);
    });

    useEffect(() => {
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        if (Object.keys(objLastTickData).length > 0) {
            const arrLastTickData = objLastTickData[detailedEvent?.nSegmentId + "_" + detailedEvent?.scripobj?.ODINCode];
            if (arrLastTickData?.length > 0) {
                handleEventsLiveData(arrLastTickData);
            }
        }
    }, [detailedEvent]);


    // Hari K :23-02-2024:given check to allow scrip to trade or not -start
    // const handleBuyAndSell = async (value) => {
    //     if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 02-04-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
    //         dispatch(handleModal([{ "EVENTS_DETAILS": false }]));
    //         const buySell = value == "buy" ? 0 : 1;
    //         await openOrderEntryModal(null, null, objLoginSession, eventData?.nSegmentId, eventData?.scripobj?.ODINCode, buySell);
    //     } else { }//Ameersha N - 02-04-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
    // };
    // Hari K :23-02-2024:given check to allow scrip to trade or not -end

    // Hari K: events LTP functionality-end
    const handleClose = () => {
        dispatch(handleModal([{ "EVENTS_DETAILS": false }]));
        setEventData({});
    };

    // const handleCreatWatchList = async () => {
    //     // Hari K :23-02-2024: to add events scrip to watchlist -start
    //     const arrScrips = [{ mkt: getApiExchangeNameFromMktSegId(eventData?.nSegmentId), token: eventData?.scripobj?.ODINCode }];
    //     const objResp = await getScripbyTokenAndMktSegId(arrScrips);
    //     if (objResp?.data?.result?.length) {
    //         const gridFormatData = convertScripResponseWatchlistGrid(objResp?.data?.result);
    //         dispatch(setArrScripToBeAdded(gridFormatData));
    //         dispatch(handleModal([{ "GLOBAL_SEARCH_ADDSCRIP_MODAL": true }]));
    //         dispatch(handleModalData({ rowDetails: "events" }));
    //         dispatch(handleModal([{ "EVENTS_DETAILS": false }]));
    //     } else {
    //         dispatch(toastConfig({ autoDismiss: true, show: true, message: `Unable to get scrip details` }));
    //     }
    //     // Hari K :23-02-2024: to add events scrip to watchlist -start
    // };

    const handleOverview = useCallback(async () => {
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (isNotExpired) {
            await dispatch(setScripOverviewData([...arrRowData[0]]));
            await dispatch(handleModalData({ rowDetails: arrRowData[0], mktSegmentToken: getMktSegIdFromMappedMktSegId(eventData?.nSegmentId) + '_' + eventData?.scripobj?.ODINCode }));
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
        }
    }, [arrRowData]);

    const handleAddToWatchlist = () => {
        dispatch(setArrScripToBeAdded(arrRowData));
        dispatch(handleModal([{ 'GLOBAL_SEARCH_ADDSCRIP_MODAL': true }], true));
    };

    const handleChart = () => {
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (isNotExpired) {
            if(!isUserIsAGuest('chart')){
                dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
                dispatch(setScripOverviewData(arrRowData[0]));
                dispatch(handleModalData({ tab: 'analysis' }));
                dispatch(setIsIndicesOverview(false));
            }
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
        }
    };

    const handleSetAlert = (scrip) => {
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(scrip[0][WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (!isNotExpired) {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
            return;
        }
        setTimeout(() => {
            dispatch(toastConfig({}));
        }, 50);
        dispatch(handleModalData({
            AlertData: {
                symbol: scrip[0][WATCHLIST_GRID_INDEX.SYMBOL],
                exchange: scrip[0][WATCHLIST_GRID_INDEX.EXCHANGE],
                series: scrip[0][WATCHLIST_GRID_INDEX.INSTRUMENT]?.substring(0, 2),
                description: getScripDisplayDescription(scrip),
                token: scrip[0][WATCHLIST_GRID_INDEX.TOKEN],
                mktId: scrip[0][WATCHLIST_GRID_INDEX.SEGMENT_ID],
                mappedMktId: scrip[0][WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                decimalLocator: scrip[0][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                decimalLocator_length: scrip[0][WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                exchange_segement: getApiExchangeNameFromMktSegId(scrip[0][WATCHLIST_GRID_INDEX.SEGMENT_ID]),
                expiryDate: scrip[0][WATCHLIST_GRID_INDEX.EXPIRYDATE],
                instrument: scrip[0][WATCHLIST_GRID_INDEX.INSTRUMENT],
            },
            isShowAlerts: true
        }));

        dispatch(handleModal([{ "SET_ALERT_MODAL": true }], true));
    };

    const onBuySellClick = useCallback((strBuySell) => {
        if(!isUserIsAGuest('buy_sell')){
            if (arrRowData[0]?.[WATCHLIST_GRID_INDEX?.NSPREAD] == 1) {
                var spreadPaylod =
                {
                    "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(arrRowData[0][WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API,
                    "symbol": arrRowData[0][WATCHLIST_GRID_INDEX.SYMBOL],
                    "token": arrRowData[0][WATCHLIST_GRID_INDEX.TOKEN]
                };
                sendTouchlineRequest([
                    { exchangeId: arrRowData[0][WATCHLIST_GRID_INDEX.SEGMENT_ID], token: arrRowData[0][WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true },

                ]);
                dispatch(getSpreadOrder(spreadPaylod));
                dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));
                dispatch(handleModalData({ data: { spreadArr: arrRowData[0], orderEntryTab: 'multi_scrip', activeTabKey: 'spread' } }), true);
                dispatch(handleModal([{ "HOT_PURSUIT_DATA": false }, { "NEWS_DETAILS": false }]));
            } else {
                dispatch(getScripOrderInfo({ isBuySell: strBuySell === 'BUY' ? 0 : 1, activeExchangeId: arrRowData[0][WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: arrRowData[0] }));
                dispatch(getExchangeWiseScripInfo(arrRowData[0]));
                dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }], true));
                dispatch(handleModal([{ "HOT_PURSUIT_DATA": false }, { "NEWS_DETAILS": false }]));
            }
        }

    }, [arrRowData]);


    return (
        <BzModal show={modals['EVENTS_DETAILS']} onHide={handleClose} size="lg" centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleClose}>&nbsp;</div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    {modals['MARKET_OVERVIEW_MODAL'] === true ? '' :
                        <Row className='g-0 mb-2'>
                            <Col md={9}>
                                <BzHeading className='font-medium font-size5 color-text text-uppercase text-truncate'>{detailedEvent?.title}</BzHeading>
                                <div className='d-flex align-items-center'>
                                    {detailedEvent?.exchangeType.length > 0 ?
                                        <div className='chips-wrap'>
                                            <BzChip className='exchange-chip'>{detailedEvent?.exchangeType}</BzChip>
                                        </div> : ''}
                                    <div className='font-regular font-size4 color-text color-positive ms-1'>{eventData?.ltp}</div>
                                    <div className={`font-regular font-size4 color-text ms-1 me-1 ${eventData?.changeInPrice > 0 ? "color-positive" : "color-negative"} `}>{eventData?.changeInPrice}</div>
                                    <div className={`font-regular font-size4 color-text ${eventData?.changeInPersent > 0 ? "color-positive" : "color-negative"} `}>({eventData?.changeInPersent}%)</div>
                                </div>
                            </Col>
                            {detailedEvent?.scripobj !== "-" ?
                                <Col md={3} className='d-flex justify-content-end align-items-center'>
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Overview'}>
                                        <button className={`btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2 ${arrRowData?.length ? '' : 'disabled'}`} onClick={handleOverview}>
                                            <div class="icon-16 icon-eye icon-primary"></div>
                                        </button>
                                    </BzToolTip>
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Chart'}>
                                        <button className={`btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2 ${arrRowData?.length ? '' : 'disabled'}`} onClick={handleChart}>
                                            <div class="icon-16 icon-graph icon-primary"></div>
                                        </button>
                                    </BzToolTip>
                                    {
                                        objCFT.ALERT === FACILITY_NUM.ON && (
                                            <BzToolTip placement={'bottom'} TooltipMsg={'Alert'}>
                                                <button className={`btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2 ${arrRowData?.length ? '' : 'disabled'}`} onClick={handleSetAlert?.bind(this, arrRowData)}>
                                                    <div class="icon-16 icon-alert icon-primary"></div>
                                                </button>
                                            </BzToolTip>)}
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Add to watchlist'}>
                                        <button className={`btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2 ${arrRowData?.length ? '' : 'disabled'}`} onClick={handleAddToWatchlist}>
                                            <div class="icon-16 icon-add-circle icon-primary"></div>
                                        </button>
                                    </BzToolTip>
                                    <button onClick={() => onBuySellClick('BUY')} className={`btn btn-sm btn-positive text-uppercase me-2 ${arrRowData?.length ? '' : 'disabled'}`}>&nbsp;B&nbsp;</button>
                                    <button onClick={() => onBuySellClick('SELL')} className={`btn btn-sm btn-negative text-uppercase ${arrRowData?.length ? '' : 'disabled'}`}>&nbsp;S&nbsp;</button>
                                </Col> : null}
                        </Row>}
                    <Row className='g-0 mb-2'>
                        <Col>
                            <div className='font-medium font-size5 color-text'>{detailedEvent?.eventType}</div>
                        </Col>
                    </Row>
                    <Row className='g-0 mb-2'>
                        <Col>
                            <div className='font-medium font-size5 color-text'>{detailedEvent?.eventDate?.split("-")[0]} {detailedEvent?.eventDate?.split("-")[1]}  <span className='font-medium font-size5 color-subtext'>'{detailedEvent?.eventDate?.split("-")[2].slice(-2)}</span></div>
                        </Col>
                    </Row>
                    <Row className='g-0 mb-2'>
                        <div className='font-regular font-size2 color-text text-justify'>{detailedEvent?.description}</div>
                    </Row>
                </Container>
            </BzModalBody>
        </BzModal>
    );
};

export default memo(EventDetailsModal);
// Hari K : 20-06-2023 : BT-107424 - Breeze -events-detailed eventmodal-end